(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bb-gifts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-gifts')) {
    const pairsOf = (bar) => {
      if (!bar) return 1;
      const parts = bar.querySelectorAll('.kaching-bundles__bar-title, .kaching-bundles__bar-subtitle');
      const match = Array.from(parts, (el) => el.textContent).join(' ').match(/([0-9]+)[^0-9a-z]{0,3}pairs?(?![a-z])/i);
      return match ? parseInt(match[1], 10) : 1;
    };

    class BbGifts extends HTMLElement {
      connectedCallback() {
        this.update = this.update.bind(this);
        this.tries = 0;
        this.poll = setInterval(() => {
          this.tries += 1;
          if (this.hook() || this.tries > 60) clearInterval(this.poll);
        }, 250);
        this.update();
      }

      disconnectedCallback() {
        clearInterval(this.poll);
        if (this.mo) this.mo.disconnect();
        if (this.pmo) this.pmo.disconnect();
      }

      picker() {
        const scope = this.closest('.product-details, product-component, form, section') || document;
        return scope.querySelector('kaching-bundle, .kaching-bundles') || document.querySelector('kaching-bundle, .kaching-bundles');
      }

      /* Sit right under the pack picker, above Add to Cart */
      place() {
        const kb = this.picker();
        const host = kb && (kb.closest('kaching-bundle') || kb);
        if (!host || host.parentElement !== this.parentElement) return;
        if (host.compareDocumentPosition(this) & Node.DOCUMENT_POSITION_PRECEDING) host.after(this);
      }

      hook() {
        const kb = this.picker();
        if (!kb || !kb.querySelector('.kaching-bundles__bar')) return false;
        this.place();
        if (this.parentElement) {
          this.pmo = new MutationObserver(() => this.place());
          this.pmo.observe(this.parentElement, { childList: true });
        }
        this.mo = new MutationObserver(() => {
          clearTimeout(this.t);
          this.t = setTimeout(this.update, 40);
        });
        this.mo.observe(kb, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
        this.update();
        return true;
      }

      update() {
        const kb = this.picker();
        const bar = kb && kb.querySelector('.kaching-bundles__bar--selected');
        const pairs = pairsOf(bar);
        this.querySelectorAll('[data-gift]').forEach((gift) => {
          const need = parseInt(gift.dataset.unlock || '0', 10);
          gift.classList.toggle('is-locked', need > pairs);
        });
      }
    }
    customElements.define('bb-gifts', BbGifts);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bb-review-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-review-carousel')) {
    const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class BbReviewCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-bbrc-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.querySelectorAll('[data-bbrc-slide]'));
        this.index = 0;
        this.n = this.slides.length;
        this.slides.forEach((s, i) => s.setAttribute('aria-label', `${i + 1} of ${this.n}`));
        this.buildDots();

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => {
            const w = this.track.clientWidth;
            if (!w) return;
            const i = Math.round(this.track.scrollLeft / w);
            if (i !== this.index) this.mark(i);
          });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        const prev = this.querySelector('[data-bbrc-prev]');
        const next = this.querySelector('[data-bbrc-next]');
        if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
        if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
        if (this.n < 2) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
        }

        this.onDown = this.onDown.bind(this);
        this.track.addEventListener('pointerdown', this.onDown);
        this.track.addEventListener('click', (e) => {
          if (this.dragged) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1, true); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1, true); }
        });

        /* Keep the place when the column changes width */
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => {
            const w = this.track.clientWidth;
            if (w) this.track.scrollLeft = this.index * w;
            this.fitStack();
          });
          this.ro.observe(this.track);
        }

        this.startAutoplay();

        /* Theme editor: show the review picked in the sidebar */
        this.onSelect = (event) => {
          const id = event.detail && event.detail.blockId;
          if (!id) return;
          const i = this.slides.findIndex((s) => (s.getAttribute('data-shopify-editor-block') || '').includes(id));
          if (i >= 0) {
            this.paused = true;
            this.go(i, false);
          }
        };
        document.addEventListener('shopify:block:select', this.onSelect);
        this.onDeselect = () => { this.paused = false; };
        document.addEventListener('shopify:block:deselect', this.onDeselect);

        if (this.dataset.bbrcSlot === 'media') {
          this.onWinResize = () => this.fitStack();
          window.addEventListener('resize', this.onWinResize);
          const stack = this.closest('.bbrc-stack');
          if (stack && this.ro) this.ro.observe(stack);
          this.fitStack();
        }
      }

      disconnectedCallback() {
        clearInterval(this.auto);
        if (this.ro) this.ro.disconnect();
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:block:deselect', this.onDeselect);
        if (this.onWinResize) window.removeEventListener('resize', this.onWinResize);
      }

      buildDots() {
        this.dots = [];
        const box = this.querySelector('[data-bbrc-dots]');
        if (!box) return;
        box.innerHTML = '';
        if (this.n < 2) return;
        this.slides.forEach((_, i) => {
          const d = document.createElement('button');
          d.type = 'button';
          d.className = 'bbrc__dot';
          d.setAttribute('aria-label', `Show review ${i + 1}`);
          d.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          d.addEventListener('click', () => this.go(i, true));
          box.appendChild(d);
          this.dots.push(d);
        });
      }

      /* Loops round at both ends, like UpAiry's */
      go(i, user) {
        if (!this.n) return;
        const idx = ((i % this.n) + this.n) % this.n;
        if (user) this.hold();
        const w = this.track.clientWidth;
        if (w) this.track.scrollTo({ left: idx * w, behavior: reduce() ? 'auto' : 'smooth' });
        this.mark(idx);
      }

      mark(i) {
        this.index = Math.max(0, Math.min(this.n - 1, i));
        this.dots.forEach((d, k) => d.setAttribute('aria-current', k === this.index ? 'true' : 'false'));
      }

      /* Mouse drag; touch screens and trackpads swipe natively */
      onDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || this.n < 2) return;
        const t = this.track;
        const startX = event.clientX;
        const startLeft = t.scrollLeft;
        this.dragged = false;
        const move = (e) => {
          const dx = e.clientX - startX;
          if (!this.dragged && Math.abs(dx) > 6) {
            this.dragged = true;
            t.classList.add('is-dragging');
          }
          if (this.dragged) t.scrollLeft = startLeft - dx;
        };
        const up = (e) => {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', up);
          if (!this.dragged) return;
          const w = t.clientWidth || 1;
          const dx = e.clientX - startX;
          let i = Math.round(startLeft / w);
          if (dx < -40) i += 1;
          else if (dx > 40) i -= 1;
          i = Math.max(0, Math.min(this.n - 1, i));
          t.classList.remove('is-dragging');
          this.hold();
          t.scrollTo({ left: i * w, behavior: reduce() ? 'auto' : 'smooth' });
          this.mark(i);
          setTimeout(() => { this.dragged = false; }, 0);
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
      }

      /* After a tap, swipe, drag or arrow click, wait 8 seconds before moving on again */
      hold() {
        this.holdUntil = Date.now() + 8000;
      }

      /* Moves to the next review every few seconds (also in the theme editor). It stops while a
         mouse is over it or a keyboard user is on it, and waits after the shopper moves it. */
      startAutoplay() {
        const secs = parseInt(this.dataset.autoplay || '0', 10);
        if (!(secs > 0) || this.n < 2 || reduce()) return;
        this.paused = false;
        this.holdUntil = 0;
        this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.paused = true; });
        this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.paused = false; });
        this.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) this.paused = true; });
        this.addEventListener('focusout', () => { if (!this.matches(':hover')) this.paused = false; });
        this.track.addEventListener('touchstart', () => this.hold(), { passive: true });
        this.auto = setInterval(() => {
          if (this.paused || document.hidden || Date.now() < this.holdUntil || !this.track.clientWidth) return;
          this.go(this.index + 1, false);
        }, secs * 1000);
      }

      /* Desktop: the gallery and this carousel stick together. When both are taller than the
         window, stick by the bottom edge so the reviews never sit below the fold. */
      fitStack() {
        const stack = this.closest('.bbrc-stack');
        if (!stack) return;
        const h = stack.offsetHeight;
        const view = window.innerHeight;
        const top = h && h > view ? Math.round(view - h - 16) : 0;
        stack.style.setProperty('--bbrc-top', `${top}px`);
      }
    }
    customElements.define('bb-review-carousel', BbReviewCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bb-ship"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-ship')) {
    class BbShip extends HTMLElement {
      connectedCallback() {
        const days = Math.max(0, parseInt(this.dataset.days || '0', 10));
        const skip = new Set((this.dataset.skip || '').split(',').map((d) => d.trim()).filter(Boolean));
        const key = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        const open = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !skip.has(key(d));
        const date = new Date();
        date.setHours(12, 0, 0, 0);
        let left = days;
        let guard = 0;
        if (left === 0) {
          while (!open(date) && guard++ < 60) date.setDate(date.getDate() + 1);
        } else {
          while (left > 0 && guard++ < 90) {
            date.setDate(date.getDate() + 1);
            if (open(date)) left -= 1;
          }
        }
        const lang = document.documentElement.lang || 'en-US';
        let text;
        if (this.dataset.style === 'short') {
          text = new Intl.DateTimeFormat(lang, { month: 'short', day: 'numeric' }).format(date);
        } else {
          const n = date.getDate();
          const s = n % 100 >= 11 && n % 100 <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
          text = `${new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date)} ${n}${s}`;
        }
        const slot = this.querySelector('[data-ship-date]');
        if (slot) slot.textContent = text;
        this.hidden = false;
      }
    }
    customElements.define('bb-ship', BbShip);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bb-ugc-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-vcar')) {
    class BbVcar extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-vcar-track]');
        this.fill = this.querySelector('[data-vcar-fill]');
        if (!this.track) return;
        this.dragged = false;
        this.update = this.update.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onDown = this.onDown.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.addEventListener('click', this.onClick);
        this.track.addEventListener('pointerdown', this.onDown);
        document.addEventListener('shopify:block:select', this.onSelect);
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.update);
          this.ro.observe(this.track);
        }
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) this.stop(entry.target);
            });
          }, { threshold: 0.2 });
          this.querySelectorAll('.bb-vcar__card').forEach((card) => this.io.observe(card));
        }
        this.update();
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
        document.removeEventListener('shopify:block:select', this.onSelect);
      }

      /* The bar fills to the share of the videos seen so far */
      update() {
        if (!this.track || !this.fill) return;
        const t = this.track;
        const total = t.scrollWidth;
        const pct = total > 0 ? Math.min(100, ((t.scrollLeft + t.clientWidth) / total) * 100) : 100;
        this.fill.style.width = pct.toFixed(2) + '%';
      }

      onClick(event) {
        const button = event.target.closest('[data-vcar-play]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        if (this.dragged) return;
        const card = button.closest('.bb-vcar__card');
        const video = card && card.querySelector('video');
        if (!video) return;
        if (!video.paused) {
          this.stop(card);
          return;
        }
        this.querySelectorAll('.bb-vcar__card.is-playing').forEach((other) => {
          if (other !== card) this.stop(other);
        });
        video.muted = false;
        card.classList.add('is-playing');
        button.setAttribute('aria-label', 'Pause video');
        const playing = video.play();
        if (playing && playing.catch) {
          playing.catch(() => {
            video.muted = true;
            video.play().catch(() => this.stop(card));
          });
        }
      }

      stop(card) {
        const video = card.querySelector('video');
        if (video && !video.paused) video.pause();
        card.classList.remove('is-playing');
        const button = card.querySelector('[data-vcar-play]');
        if (button) button.setAttribute('aria-label', 'Play video');
      }

      /* Drag to scroll with a mouse; touch screens and trackpads scroll natively */
      onDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        const t = this.track;
        const startX = event.clientX;
        const startLeft = t.scrollLeft;
        this.dragged = false;
        const move = (e) => {
          const dx = e.clientX - startX;
          if (!this.dragged && Math.abs(dx) > 6) {
            this.dragged = true;
            t.classList.add('is-dragging');
          }
          if (this.dragged) t.scrollLeft = startLeft - dx;
        };
        const up = () => {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', up);
          t.classList.remove('is-dragging');
          window.setTimeout(() => { this.dragged = false; }, 0);
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
      }

      /* Theme editor: scroll the selected video into view */
      onSelect(event) {
        const card = event.target && event.target.closest ? event.target.closest('.bb-vcar__card') : null;
        if (!card || !this.contains(card)) return;
        this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft - 4, behavior: 'smooth' });
      }
    }
    customElements.define('bb-vcar', BbVcar);
  }
  } catch(e) { console.error(e); }
})();

})();
